import { FC } from 'react'
import { IconPaths, KTSVG } from '_metronic/helpers'

type TriagemTagProps = {
  texto: string
  icone?: IconPaths
  className?: string
}

/**
 * Aviso textual ao lado do selo de risco ("Protocolo em validação", "Aguardando revisão de
 * reavaliação"). É neutra de propósito: usar cor de risco aqui faria o aviso parecer uma
 * classificação.
 */
export const TriagemTag: FC<TriagemTagProps> = ({ texto, icone, className }) => (
  <span
    className={`badge bg-light text-gray-700 border border-gray-300 d-inline-flex align-items-center gap-1 ${
      className ?? ''
    }`}
  >
    {icone && <KTSVG path={icone} className='svg-icon-gray-700' ariaHidden />}
    {texto}
  </span>
)
